var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.global.xgc ? _c('route-not-found') : _c('v-container', {
    staticClass: "pt-0"
  }, [_c('error-dialog', {
    attrs: {
      "status": _vm.loadStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.addStatus
    }
  }), _vm.product ? _c('dialog-scroll-lock', {
    attrs: {
      "width": "400",
      "value": true
    },
    on: {
      "input": function ($event) {
        _vm.$router.push(_vm.$routeAssign({
          params: {}
        }));
      }
    }
  }, [_c('v-card', [_c('v-btn', {
    staticClass: "float-right mt-3 mr-3",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        _vm.$router.push(_vm.$routeAssign({
          params: {}
        }));
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1), _c('v-card-title', {
    staticClass: "pa-4"
  }, [_vm._v("Gift card")]), _c('v-card-subtitle', {
    staticClass: "px-4 mt-0"
  }, [_c('v-card', {
    staticClass: "float-right ml-4 mb-1 gc-border",
    attrs: {
      "width": "100"
    }
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 337 / 213,
      "src": _vm.product.img
    }
  })], 1), _c('div', {
    staticClass: "overline short",
    staticStyle: {
      "color": "rgba(0, 0, 0, 0.87)"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.product.name)
    }
  }), _c('giftcard-details', {
    attrs: {
      "src": _vm.product.src,
      "product-id": _vm.product.id
    }
  })], 1), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _c('div', {
    staticClass: "px-4",
    class: {
      'pt-4': _vm.product.values.fixed,
      'pb-4': !_vm.product.values.fixed
    }
  }, [_c('v-form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return function () {
          return _vm.amtValid && _vm.add();
        }.apply(null, arguments);
      }
    },
    model: {
      value: _vm.amtValid,
      callback: function ($$v) {
        _vm.amtValid = $$v;
      },
      expression: "amtValid"
    }
  }, [_c('giftcard-amount', {
    attrs: {
      "cur": _vm.product.cur,
      "allowed-values": _vm.product.values,
      "max": _vm.maxValue
    },
    model: {
      value: _vm.amt,
      callback: function ($$v) {
        _vm.amt = $$v;
      },
      expression: "amt"
    }
  })], 1)], 1), _vm.noAmtValid ? [_c('v-divider'), _c('v-card-text', {
    staticClass: "error--text font-italic pa-4"
  }, [_vm._v("Max gift card value is restricted to "), _c('currency', {
    attrs: {
      "code": _vm.$options.filters.cur(_vm.country)
    }
  }), _vm._v(_vm._s(_vm.maxValue) + " – there are no valid values that can be assigned to this gift card. Please try a different one.")], 1)] : _vm._e(), _c('v-card-actions', {
    staticClass: "pa-4"
  }, [_c('v-spacer'), _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "exact": "",
      "to": _vm.$routeAssign({
        params: {}
      })
    }
  }, [_vm._v("Cancel")]), _c('add-to-project-btn', {
    attrs: {
      "color": "primary",
      "preview": _vm.preview,
      "disabled": !_vm.amtValid,
      "loading": _vm.addStatus.pending
    },
    on: {
      "select": _vm.add
    }
  })], 1)], 2)], 1) : _vm._e(), _c('giftcard-browser', {
    attrs: {
      "search": _vm.search,
      "country": _vm.country,
      "loading-provider-id": _vm.loadStatus.pending ? _vm.providerId : null
    },
    on: {
      "input-search": function (x) {
        return _vm.search = x;
      },
      "input-country": function (x) {
        return _vm.country = x;
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }